/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaymentProvider } from '../../models/payment-provider';

export interface BillingProviderWebhookProviderPost$Params {
  provider: PaymentProvider;
}

export function billingProviderWebhookProviderPost(http: HttpClient, rootUrl: string, params: BillingProviderWebhookProviderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, billingProviderWebhookProviderPost.PATH, 'post');
  if (params) {
    rb.path('provider', params.provider, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

billingProviderWebhookProviderPost.PATH = '/billing/provider-webhook/{provider}';
